<template>
  <svg
    class="crv-vee-manager crv-svg-icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="6 5 22 22"
  >
    <path
      fill-rule="evenodd"
      d="M19.7850131,13.1913475 L19.8137619,13.2317254 C20.002558,13.4968913 21.0924016,15.0275878 22.2246313,16.6178397 L22.5647131,17.095496 C23.8100455,18.8446097 25.0027672,20.5198625 25,20.5161017 C24.6076681,22.9422088 22.6862066,23.4522193 21.5193593,23.5001498 L10,23.5001498 L21.2902606,20.5 L18.2547929,13.7051026 C17.0659829,11.2014281 14.9261348,12.19359 14.6193512,12.3521889 L14.598,12.362 L14.7976213,12.2353185 C17.4956225,10.5915177 19.0955918,12.2543984 19.7850131,13.1913475 Z M12.3681136,11.5 C12.3681136,11.5 15.2233425,13.1146587 15.5432845,13.2809177 C16.3007942,13.6748465 16.6855208,14.1268161 16.9895381,14.9790803 L14.0250078,14.9790803 C12.8744471,14.816566 12.1125943,13.4366918 12.2921093,12.0747916 L12.3681136,11.5 Z M22.491346,11.6943806 L22.491346,12.2860228 C22.491346,13.1652479 22.1138579,13.9399995 21.5402062,14.3957137 C20.857977,13.4374782 20.3639489,12.7439837 20.3617773,12.7409881 C20.3357187,12.7054146 20.3089363,12.6735858 20.2825157,12.6395102 C21.33789,12.2953842 22.491346,11.6943806 22.491346,11.6943806 L22.491346,11.6943806 Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'CrvVeeManager',
}
</script>